<!-- Draws a component with no header/footers. Useful for embedding the journey planner widget. -->
<template>
    <v-app>
        <v-main>
            <v-container>
                <div class="content">
                    <AlertComponent id="default"></AlertComponent>
                </div>

                <RouterView></RouterView>
            </v-container>
        </v-main>
    </v-app>
</template>

<style lang="scss" scoped>
.v-container {
    padding: 0;
}
.v-main, .v-application {
    background-color: transparent;
}
</style>
